import { render } from "./AdminProjects.vue?vue&type=template&id=d70e0654&scoped=true"
import script from "./adminprojects.view.js?vue&type=script&lang=js&external"
export * from "./adminprojects.view.js?vue&type=script&lang=js&external"

import "./adminprojects.css?vue&type=style&index=0&id=d70e0654&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70e0654"]])

export default __exports__